import { Box } from "@chakra-ui/react"
import { useState } from "react"
import Header from "./Header"
import Sidebar from "./old-Sidebar"

const Layout = ({ children }: { children: React.ReactNode }) => {
  const [isMobileOpen, setIsMobileOpen] = useState(false)

  const toggleSidebar = () => {
    setIsMobileOpen(!isMobileOpen)
  }

  return (
    <Box position="relative" minH="100vh">
      {/* Background Watermark */}
      <Box
        position="absolute"
        top="0"
        left="0"
        width="100%"
        height="100%"
        backgroundImage="url('/src/assets/dsa-bg.svg')"
        backgroundRepeat="repeat"
        backgroundSize="20% auto" // Adjust the size of the watermark
        backgroundPosition="center center"
        backgroundAttachment="fixed"
        opacity="0.1"
        zIndex="-1" // Pushes the watermark behind all other content
      />

      {/* Main Layout */}
      <Header toggleSidebar={toggleSidebar} />
      <Box display="flex" flexDirection="column" overflowY="scroll">
        <Box display="flex" flex="1">
          {/* Sidebar */}
          <Sidebar isMobileOpen={isMobileOpen} />
          {/* Main Content */}
          <Box
            flex="1"
            pt="2rem"
            transition="margin-left 0.3s ease"
            marginTop="20"
            marginLeft={{ base: isMobileOpen ? "60%" : "0", md: "250px" }}
            ml={isMobileOpen ? "15%" : "0"}
            w={{ base: "full", md: "auto" }}
          >
            {children}
          </Box>
        </Box>
      </Box>
    </Box>
  )
}

export default Layout
